import React from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import { TableCell, TableRow } from "@mui/material";
import CreatableSelect from 'react-select/creatable';
import axios from "axios";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import { pcSelectStyles, pcSelectTheme } from "../../Components/PCSelect";
import { formatAmount } from '../../helper';

import AmountInput from '../../Components/AmountInput';
import FormCard from './shared/FormCard';
class JobServices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addService: false,
            ServicesList: [],
            repairTypeList: [
                { value: 'Phone', label: 'Phone' },
                { value: 'Tablet', label: 'Tablet' },
                { value: 'Laptop', label: 'Laptop' },
                { value: 'Gaming Console', label: 'Gaming Console' },
                { value: 'Watch', label: 'Watch' }
            ],
            repairBrandList: [],
            repairDeviceList: [],
            repairServiceList: [],

            PCSS_ID: "",
            DEVICE_TYPE: "",
            DEVICE_BRAND: "",
            DEVICE_NAME: "",
            SERVICE_NAME: "",
            SERVICE_COST: "",
            SERVICE_PRE_COST: ""
        };
        this.gridRef = React.createRef(null);
    }


    async getServiceByShop(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetServicesByShop.php`, {
            PC_SHOP: localStorage.getItem('PC_GRP_ATT'),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        }).then((response) => {
            let ServicesList = []
            if (response.data.success === 1) {
                ServicesList = response.data.data
                pagination.totalItems = parseInt(response.data.Page_count[0]['TOTAL_PAGE_COUNT'])
                pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50);
                this.gridRef.current?.setPaginationData(pagination)
            }
            this.setState({ ServicesList })
        }).catch((error) => {
            console.error(error);
            this.setState({ ServicesList: [] })
        }).finally(() => {
            this.props.toggleLoader(false)
        });

    }

    async handleChangeInput(fieldName, evt) {
        let targetValue
        switch (fieldName) {
            case 'DEVICE_TYPE':
                targetValue = evt
                let deviceBrand = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDeviceBrand.php`, { DEVICE: evt.value });
                let repairBrandList = []
                if (deviceBrand.data.success === 1) {
                    let devices = deviceBrand.data.data;
                    for (let i = 0; i < devices.length; i++) {
                        const device = devices[i];
                        repairBrandList.push({
                            value: device.DEVICE_BRAND,
                            label: device.DEVICE_BRAND
                        })
                    }
                }
                this.setState({ repairBrandList })
                break;

            case "DEVICE_BRAND":
                targetValue = evt
                let deviceType = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetDeviceName.php`, { BRAND: evt.value, DEVICE: this.state.DEVICE_TYPE?.value });
                let repairDeviceList = []
                if (deviceType.data.success === 1) {
                    let devices = deviceType.data.data;
                    for (let i = 0; i < devices.length; i++) {
                        const deviceName = devices[i];
                        repairDeviceList.push({
                            value: deviceName.DEVICE_NAME,
                            label: deviceName.DEVICE_NAME
                        })
                    }
                }
                this.setState({ repairDeviceList })
                break;

            case "DEVICE_NAME":
            case "SERVICE_NAME":
                targetValue = evt
                break;

            default:
                targetValue = evt.target.value
                break;
        }
        this.setState({ [fieldName]: targetValue })
    }

    hanldeEditService() {
        this.getAllServices()
        this.setState({ addService: true })
    }

    async getAllServices() {
        let formData = {
            PCAS_SERVICE_STATUS: 'Completed'
        };

        const getAllService = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllServiceRecord.php`, formData);
        let serviceData = getAllService.data
        let repairServiceList = []
        if (serviceData.success === 1) {
            for (let i = 0; i < serviceData.data.length; i++) {
                const deviceName = serviceData.data[i];
                repairServiceList.push({
                    value: deviceName.PCAS_SERVICE_NAME,
                    label: deviceName.PCAS_SERVICE_NAME
                })
            }
        }
        this.setState({ repairServiceList })
    }

    async handleSubmitService() {
        let formData = {
            PCSS_ID: this.state.PCSS_ID,
            PCSS_SHOP_NAME: localStorage.getItem('PC_GRP_ATT'),
            PCSS_DEVICE_TYPE: this.state.DEVICE_TYPE?.value,
            PCSS_DEVICE_BRAND: this.state.DEVICE_BRAND?.value,
            PCSS_DEVICE_NAME: this.state.DEVICE_NAME?.value,
            PCSS_SERVICE: this.state.SERVICE_NAME?.value,
            PCSS_SERVICE_COST: this.state.SERVICE_COST,
            PCSS_SERVICE_PREM: this.state.SERVICE_PRE_COST
        }

        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddShopService.php`, formData);
        this.handleCancelService()
        this.getServiceByShop()
    }

    handleCancelService() {
        this.setState({
            addService: false,
            PCSS_ID: "",
            DEVICE_TYPE: "",
            DEVICE_BRAND: "",
            DEVICE_NAME: "",
            SERVICE_NAME: "",
            SERVICE_COST: "",
            SERVICE_PRE_COST: ""
        })
    }

    handleUpdateShop(idx) {
        let { ServicesList } = this.state;
        this.setState({
            PCSS_ID: ServicesList[idx]['PCSS_ID'],
            DEVICE_TYPE: { value: ServicesList[idx]['PCSS_DEVICE_TYPE'], label: ServicesList[idx]['PCSS_DEVICE_TYPE'] },
            DEVICE_BRAND: { value: ServicesList[idx]['PCSS_DEVICE_BRAND'], label: ServicesList[idx]['PCSS_DEVICE_BRAND'] },
            DEVICE_NAME: { value: ServicesList[idx]['PCSS_DEVICE_NAME'], label: ServicesList[idx]['PCSS_DEVICE_NAME'] },
            SERVICE_NAME: { value: ServicesList[idx]['PCSS_SERVICE'], label: ServicesList[idx]['PCSS_SERVICE'] },
            SERVICE_COST: ServicesList[idx]['PCSS_SERVICE_COST'],
            SERVICE_PRE_COST: ServicesList[idx]['PCSS_SERVICE_PREM'],
            addService: true
        })
    }

    render() {
        let { addService } = this.state
        return (
            <Container>
                {addService === false ?
                    <PhoneClinicGrid
                        title="JOB SERVICE"
                        buttonLabel="UPDATE SERVICE"
                        getData={this.getServiceByShop.bind(this)}
                        onClickButton={this.hanldeEditService.bind(this)}
                        isEditable={true}
                        ref={this.gridRef}
                        tableHeadData={[
                            {
                                label: "DEVICE",
                                isHidden: false
                            },
                            {
                                label: "BRAND",
                                isHidden: false
                            },
                            {
                                label: "MODEL",
                                isHidden: false
                            },
                            {
                                label: "SERVICES",
                                isHidden: false
                            },
                            {
                                label: "EXPRESS",
                                isHidden: false
                            },
                            {
                                label: "PREMIUM",
                                isHidden: false
                            },
                        ]}
                    >
                        {this.state.ServicesList.map((service, idx) => (
                            <TableRow
                                className="table-rows"
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align='left' >{service.PCSS_DEVICE_TYPE}</TableCell>
                                <TableCell align='left' >{service.PCSS_DEVICE_BRAND}</TableCell>
                                <TableCell align='left' >{service.PCSS_DEVICE_NAME}</TableCell>
                                <TableCell align='left' >{service.PCSS_SERVICE}</TableCell>
                                <TableCell align='left' >{formatAmount(service.PCSS_SERVICE_COST)}</TableCell>
                                <TableCell align='left' >{service.PCSS_SERVICE_PREM}</TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleUpdateShop.bind(this, idx) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>

                    :
                    <>
                        <FormCard title={this.state.PCSS_ID ? 'Edit Job Service' : 'Add Job Service'} mode={this.state.PCSS_ID ? 'edit' : 'new'}
                            onCancel={this.handleCancelService.bind(this)}
                            onSave={this.handleSubmitService.bind(this)} saveLabel="Save">
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>DEVICE</Form.Label>
                                    <CreatableSelect
                                        styles={pcSelectStyles}
                                        theme={pcSelectTheme}
                                        isDisabled={this.state.PCSS_ID === "" ? false : true}
                                        options={this.state.repairTypeList}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_TYPE")}
                                        value={this.state.DEVICE_TYPE}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>BRAND</Form.Label>
                                    <CreatableSelect
                                        options={this.state.repairBrandList}
                                        isDisabled={this.state.PCSS_ID === "" ? false : true}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_BRAND")}
                                        styles={pcSelectStyles}
                                        theme={pcSelectTheme}
                                        value={this.state.DEVICE_BRAND}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>MODEL</Form.Label>
                                    <CreatableSelect
                                        options={this.state.repairDeviceList}
                                        isDisabled={this.state.PCSS_ID === "" ? false : true}
                                        onChange={this.handleChangeInput.bind(this, "DEVICE_NAME")}
                                        styles={pcSelectStyles}
                                        theme={pcSelectTheme}
                                        value={this.state.DEVICE_NAME}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>SERVICES</Form.Label>
                                    <CreatableSelect
                                        options={this.state.repairServiceList}
                                        isDisabled={this.state.PCSS_ID === "" ? false : true}
                                        onChange={this.handleChangeInput.bind(this, "SERVICE_NAME")}
                                        styles={pcSelectStyles}
                                        theme={pcSelectTheme}
                                        value={this.state.SERVICE_NAME}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>EXPRESS COST</Form.Label>
                                    <AmountInput
                                        value={this.state.SERVICE_COST}
                                        onChange={this.handleChangeInput.bind(this, "SERVICE_COST")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>PREMIUM COST</Form.Label>
                                    <AmountInput
                                        value={this.state.SERVICE_PRE_COST}
                                        onChange={this.handleChangeInput.bind(this, "SERVICE_PRE_COST")}
                                        style={{ width: "100%" }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        </FormCard>
                    </>

                }

            </Container >
        );
    }
}

export default JobServices;